import React from 'react';
import * as S from './styles';
import Mao from '../../../front-novo/icons/Mao.svg';
import elem from '../../../front-novo/contact/elem.png';

function Contact2() {
  return (
    <S.Main>
      <S.Container>
        <S.Div>
          {/* <div> */}
          <img src={Mao} />

          <p>
            Fale conosco pelo WhatsApp ou Instagram.Se preferir, envie um e-mail
            diretamente para nossa equipe. Estamos aqui para ajudar!
          </p>
          <S.Links>
            <a href="https://wa.me/+553198533003">
              <button>Falar pelo WhatsApp</button>
            </a>
            <a href="https://www.instagram.com/travessias.psicanalise/">
              <button>Falar pelo Instagram</button>
            </a>
          </S.Links>
          {/* <img className="elem" src={elem} /> */}
          {/* </div> */}
        </S.Div>
        <hr />
        <S.Form
          action="https://formsubmit.co/travessias.psicanalise@gmail.com
          "
          method="POST"
        >
          <p>ENVIE UMA MENSAGEM</p>
          <input type="text" name="name" placeholder="Nome" required />
          <input type="email" name="email" placeholder="E-mail" />
          <input type="text" name="text" placeholder="Assunto" />
          <textarea rows={5} placeholder="Conteúdo" />
          <button type="submit">Enviar</button>
        </S.Form>
      </S.Container>
    </S.Main>
  );
}

export default Contact2;
